import client from '@/api/base';

export default {
// Action Plan
  async getActionPlan() {
    const response = await client.get('coaching/engagement/lga/ap/');
    return response;
  },

  async getNextActionPlan() {
    const response = await client.get('coaching/engagement/lga/ap/next/');
    return response;
  },

  async getActionPlanStat() {
    const response = await client.get('coaching/engagement/lga/ap/overview/');
    return response;
  },

  async createActionPlan(data) {
    const response = await client.post('coaching/engagement/lga/ap/', data);
    return response;
  },

  async createNextActionPlan(data) {
    const response = await client.post('coaching/engagement/lga/ap/next/', data);
    return response;
  },

  async updateActionPlan(data) {
    const response = await client.patch('coaching/engagement/lga/ap/', data);
    return response;
  },

  async updateNextActionPlan(data) {
    const response = await client.patch('coaching/engagement/lga/ap/next/', data);
    return response;
  },

  // Action Plan Submit
  async getActionPlanSubmit() {
    const response = await client.get('coaching/engagement/lga/ap/submit/');
    return response;
  },

  async submitActionPlanSurvey(data) {
    const response = await client.post('coaching/engagement/lga/ap/submit/', data);
    return response;
  },

  async publishActionPlan(data) {
    const response = await client.post('events/engagement/lga/ap/publish/', data);
    return response;
  },
};
